/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable radix */
import React, { useEffect, useState } from 'react';

import { Select } from '@atoms';
import { SEARCHABLE_SELECT_PROPS } from '@constants';

const SearchableEntitySelect = React.forwardRef(
  (
    { onChange,playlistId ,onSearch ,perPage = 10, queryVariables = {}, name, useList, placeholder, filterList, ...props },
    ref,
  ) => {
    const [eventIdWa, setEventId] = React.useState(null);
    const { resolvedData, setQuery, isFetching } = useList({
      perPage,
      ...(eventIdWa && { eventIdWa }),
      ...queryVariables,
    });





    const getIdInName = (data) => {
      const returnData = [];
      // map through original list to update name to have id
      data.map((item) => {
        const event = {
          ...item,
          showIdList: true,
          name: `${item.eventIdWa} - ${item.name}`,
        };
        return returnData.push(event);
      });
      return returnData.length ? returnData : data;
    };

    let dataList = resolvedData?.data;
    dataList = props?.showIdList ? getIdInName(dataList) : dataList;
    const serverData = filterList?.(dataList) || dataList;


    const handleChange = (entity) => {


      // eslint-disable-next-line no-unused-expressions
      onChange?.(entity);
      if (!entity) {
        setQuery('');
      }
    };

    const handleSearch = (value) => {
      // eslint-disable-next-line no-unused-expressions
      onSearch?.(value);
      if (name === 'event' && !!parseInt(value)) {
        setEventId(parseInt(value));
      } else {
        setEventId(null);
        setQuery(value);
      }
    };

    return (
      <Select.Entities
        ref={ref}
        placeholder={(playlistId === undefined || playlistId === null || playlistId === '') ? !props.disabled && placeholder : serverData.find(d => d.id === playlistId)?.title}
        loading={isFetching}
        onSearch={handleSearch}
        onChange={handleChange}
        {...SEARCHABLE_SELECT_PROPS}
        {...props}
        entities={serverData}
      />
    );
  },
);

export default SearchableEntitySelect;
